import { mailCreateDraftCommand } from './mail_createDraft';

export const mailAppCommands = [
  mailCreateDraftCommand,
];
